<template>
<div class="chapter">
<div class="inner_page">
<p><a id="als"></a></p>
<div class="fmhT"><i>Other Books by Studs Terkel</i></div>
<div class="ctag1">American Dreams <br/><i>Lost and Found</i></div>
<div> <br/></div><div class="ctag1">Division Street <br/><i>America</i></div>
<div> <br/></div><div class="ctag1">Giants of Jazz</div>
<div> <br/></div><div class="ctag1">“The Good War” <br/><i>An Oral History of World War II</i></div>
<div> <br/></div><div class="ctag1">Hard Times <br/><i>An Oral History of the Great Depression</i></div>
<div> <br/></div><div class="ctag1">Hope Dies Last <br/><i>Keeping the Faith in Troubled Times</i></div>
<div> <br/></div><div class="ctag1">My American Century</div>
<div> <br/></div><div class="ctag1">The Spectator <br/><i>Talk About Movies and Plays with the People Who Make Them</i></div>
<div> <br/></div><div class="ctag1">Talking to Myself <br/><i>A Memoir of My Times</i></div>
<div> <br/></div><div class="ctag1">Will the Circle Be Unbroken? <br/><i>Reflections on Death, Rebirth, and Hunger for a Faith</i></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// stud_9781595587664_oeb_als_r1.vue?18a0998f